import { Component, Input, OnInit } from '@angular/core';
import { InterfaceCheckPoint } from 'app/models/check-point.model';
import { InterfaceEmployee } from 'app/models/employee.model';
import { InterfaceJob } from 'app/models/job.model';
import { InterfaceProcedure } from 'app/models/procedure.model';
import { EmployeeService } from 'app/services/employee.service';
import { take } from 'rxjs/operators';
import { timezone } from 'assets/constants/timezone';
import { SweetalertService } from 'app/services/sweetalert.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DoCheckPointComponent } from '../do-check-point/do-check-point.component';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-my-activities',
  templateUrl: './my-activities.component.html',
  styleUrls: ['./my-activities.component.scss']
})
export class MyActivitiesComponent implements OnInit {

  @Input() user: InterfaceEmployee;
  job: InterfaceJob;
  procedures: InterfaceProcedure[] = [];
  checkPoints: InterfaceCheckPoint[] = [];
  checkPointData: any = {};
  selectedCheckPointRow = -1;
  isSavingCheckPoint = false;
  selectedCheckPoint: InterfaceCheckPoint;
  formCheckPoint = new FormGroup({
    comments: new FormControl(null, Validators.required)
  });
  councils: any[] = [];
  reports: any[] = [];

  constructor(
    protected employeeService: EmployeeService,
    public swal: SweetalertService,
    public modal: NgbModal
  ) { }

  async ngOnInit(): Promise<void> {
    this.user = await this.employeeService.getCurrentUser();
    this.getJobInformation();
  }

  getJobInformation(): void {
    this.employeeService.getJob(this.user.jobId).pipe(take(1)).subscribe((jobResult: InterfaceJob) => {
      this.job = jobResult;
      this.getProcedures();
      this.getCheckPoints();
      this.getCouncils();
      this.getReports();
    }, (error: any) => {
      console.error(error);
    });
  }

  getProcedures(): void {
    this.employeeService.getProcedures(this.job.id).pipe(take(1)).subscribe((proceduresResult: InterfaceProcedure[]) => {
      this.procedures = proceduresResult;
    }, (error: any) => {
      console.error(error);
    });
  }

  getCheckPoints(): void {
    this.employeeService.getCheckPoints(this.job.id).pipe(take(1)).subscribe((checkPointsResult: InterfaceCheckPoint[]) => {
      this.checkPoints = checkPointsResult;
      for (let i = 0; i < this.checkPoints.length; i++) {
        this.getCheckPointsData(i);
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  getCheckPointsData(indexCheckPoint: number): void {
    this.employeeService.getCheckPointsEmployees(this.checkPoints[indexCheckPoint], this.user.id).pipe(take(1)).subscribe((checkPointDataResult: any) => {
      if (checkPointDataResult && checkPointDataResult.length > 0) {
        this.checkPointData[this.checkPoints[indexCheckPoint].id] = true;
      } else {
        this.checkPointData[this.checkPoints[indexCheckPoint].id] = false;
      }
    }, (error: any) => {
      console.error(error);
    });
  }

  getCouncils(): void {
    this.employeeService.getCouncils(this.job.id).pipe(take(1)).subscribe((result: any) => {
      this.councils = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  getReports(): void {
    this.employeeService.getReports(this.job.id).pipe(take(1)).subscribe((result: any) => {
      this.reports = result;
    }, (error: any) => {
      console.error(error);
    });
  }

  doCheckPoint(checkPoint: InterfaceCheckPoint): void {
    const modalRef = this.modal.open(DoCheckPointComponent, {
      backdrop: 'static',
      animation: true,
      centered: true
    });
    modalRef.componentInstance.checkPoint = checkPoint;
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.job = this.job;
    modalRef.componentInstance.role = 'Employee';
    modalRef.result.then((result) => {
      if (result && result.success) {
        this.checkPointData[checkPoint.id] = true;
      }
    });
  }

  returnDateFormat(unixDate: number): string {
    return dayjs.unix(unixDate).tz(timezone).format('DD/MM/YYYY HH:mm');
  }

  // open a new window with the url of the file
  downloadFile(url: string): void {
    window.open(url);
  }

}
